import { render, staticRenderFns } from "./legalPersonInformation.vue?vue&type=template&id=54cb7ee3&scoped=true&"
import script from "./legalPersonInformation.vue?vue&type=script&lang=js&"
export * from "./legalPersonInformation.vue?vue&type=script&lang=js&"
import style0 from "./legalPersonInformation.vue?vue&type=style&index=0&id=54cb7ee3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cb7ee3",
  null
  
)

export default component.exports